export const ServicesType = [
    { name: "Solo Living", value: "solo living" },
    { name: "Multi Living", value: "multi living" },
]

export const propertyRoomOpt = [
    { name: "Property", value: "property" },
    { name: "Room", value: "room" },
]

export const YesNoOptions = [
    { name: "Yes", value: "yes" },
    { name: "No", value: "no" },
]

export const PositionOptions = [
    { name: "Manager", value: "manager" },
    { name: "Executive", value: "executive" },
    { name: "Team Lead", value: "teamLead" },
];

export const TierOptions = [
    { name: "Tier 1", value: "tier1" },
    { name: "Tier 2", value: "tier2" },
    { name: "Tier 3", value: "tier3" },
    { name: "Tier 4", value: "tier4" },
];

export const TenantsOptions = [
    { name: "1 Person", value: 1 },
    { name: "2 Person", value: 2 },
    { name: "3 Person", value: 3 },
    { name: "4 Person", value: 4 },
    { name: "5 Person", value: 5 },
    { name: "6 Person", value: 6 },
    { name: "6+ Person", value: 7 },
];